import { render, staticRenderFns } from "./recommendations-table.vue?vue&type=template&id=19963e0b&"
import script from "./recommendations-table.vue?vue&type=script&lang=js&"
export * from "./recommendations-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports